<template>
    <div class="card">
        <div class="card-body">
            <pagination-table
                :data="userOrders"
                :propsToSearch="['id', ['storeProfile', STORE_PROFILES.fields.name]]"
                searchPlaceholder="Search id, store name"
                title="Most Recent Orders"
            >
                <template slot="table" slot-scope="scope">
                    <user-orders-table :data="scope.data"></user-orders-table>
                </template>
            </pagination-table>
        </div>
    </div>
</template>
<script>
import { USERS, STORE_PROFILES } from 'db'
import PaginationTable from 'Shared/Tables/PaginationTable'
import UserOrdersTable from 'Shared/Tables/UserOrdersTable'
export default {
    components: {
        UserOrdersTable,
        PaginationTable
    },
    props: {
        userOrders: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            USERS,
            STORE_PROFILES
        }
    }
}
</script>
